/**
 * Converts a time string "HH:mm" to minutes from midnight.
 * @param time "HH:mm" string
 * @returns number of minutes or 0 if invalid
 */
export const timeToMinutes = (time: string): number => {
    if (!time) return 0;
    const [hrs, mins] = time.split(':').map(Number);
    return hrs * 60 + mins;
};

/**
 * Converts minutes from midnight to a time string "HH:mm".
 * @param minutes number of minutes
 * @returns "HH:mm" string
 */
export const minutesToTime = (minutes: number): string => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};
